<div
  class="d-inline-flex align-items-start"
  [ngClass]="
    displayColumn()
      ? 'flex-column gap-1 flex-' +
        displayColumn() +
        '-row gap-' +
        displayColumn() +
        '-2'
      : 'gap-2'
  "
>
  @if (appStoreButtonLink(); as appStoreButtonLink) {
    <a
      target="_blank"
      [attr.aria-label]="appStoreButtonLink.text"
      [href]="appStoreButtonLink.href"
      [class.inverted]="inverted()"
      id="app-store-button"
      wlTrackLink
      [trackLinkInfo]="{
        rendering: { componentName: 'AppStoreButtonsComponent' },
        field: appStoreButtonLink.text || '',
        eventType: 'button-click',
        type: 'button',
      }"
    >
      <wl-app-store-logo />
      <crnt-visually-hidden>{{ appStoreButtonLink.text }}</crnt-visually-hidden>
    </a>
  }
  @if (googlePlayButtonLink(); as googlePlayButtonLink) {
    <a
      target="_blank"
      [attr.aria-label]="googlePlayButtonLink.text"
      [href]="googlePlayButtonLink.href"
      [class.inverted]="inverted()"
      id="google-play-button"
      wlTrackLink
      [trackLinkInfo]="{
        rendering: { componentName: 'AppStoreButtonsComponent' },
        field: googlePlayButtonLink.text || '',
        eventType: 'button-click',
        type: 'button',
      }"
    >
      <wl-google-play-logo />
      <crnt-visually-hidden>{{
        googlePlayButtonLink.text
      }}</crnt-visually-hidden>
    </a>
  }
</div>
